import React, { Component } from 'react'
import { routerActions } from 'connected-react-router'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Dimmer, Loader } from 'semantic-ui-react'
import AppHeader from '../components/AppHeader'
import * as Reservation from '../store/Reservations'
import ReservationReview from '../components/ReservationReview'
class ReservationPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reservation: null,
        }
    }

    async componentDidMount() {
        const { actions, confirmationNumber } = this.props
        const reservation = await actions.getReservation(confirmationNumber)
        console.log(reservation)
        this.setState({ reservation: reservation.response })
    }

    render() {
        const { reservation } = this.state

        if (!reservation) {
            return (
                <div className="app">
                    <AppHeader />
                    <Container>
                        <Dimmer active={!reservation}>
                            <Loader />
                        </Dimmer>
                    </Container>
                </div>
            )
        }

        const { confirmationNumber, onSubmit } = this.props
        const { inventory, spots, name, address, address2, city, state, zip, email, status, mobile, additionalInformation } = reservation //, cardLast4, cardExpire, cardBrand
        const { facility, event, rate } = inventory
        // const token = {
        //     card: {
        //         last4: cardLast4,
        //         brand: cardBrand,
        //         exp_month: cardExpire.split('/')[0],
        //         exp_year: cardExpire.split('/')[1]
        //     }
        // }
        const parker = { name, address, address2, city, state, zip, email, mobile } //, token};
        console.log(reservation)
        const blocks = inventory.blocks
        blocks.forEach((block) => {
            block.id = block.eventBlockId
        })
        console.log('status', status)
        return (
            <div className="app">
                <ReservationReview
                    confirmation={confirmationNumber}
                    event={event}
                    selectedFacility={{ ...facility, rate, inventoryId: inventory.id }}
                    blocks={blocks}
                    status={status === 0 ? 0 : status ? status : -1}
                    // days={days.map(d => moment.utc(d.day))}
                    parker={parker}
                    spots={spots}
                    additionalInfo={JSON.parse(additionalInformation)}
                    passedInventory={inventory}
                    onSubmit={onSubmit}
                />
            </div>
        )
    }
}

ReservationPage.propTypes = {}

const mapStateToProps = (state, ownProps) => {
    return {
        confirmationNumber: ownProps.match.params.confirmationNumber.toLowerCase(),
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Reservation.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ReservationPage)
)
